<template>

  <div id="academy_sat">

    <div class="c-img-bg c-academy-bg">

      <div class="container-xl">
        <div class="row">
          <div class="col-12">

            <!-- navigation-->
            <Navi dark-mode></Navi>

            <!-- academy -->  
            <div class="row justify-content-center">
              <div class="col-11 coll-md-10">                    
                <div class="row">
                  <div class="col-12 d-flex align-items-center flex-column">
                    <h1 class="c-h1">Workshops & Seminare</h1>  
                    <p class="c-txt-orange" style="font-weight: bold;">Glück bei der Arbeit verändert alles</p>      
                  </div>
                  <div class="col-12 py-3 col-md-8 d-flex align-items-center justify-content-center">             
                    <p class="text-center text-md-left">
                        Es schafft Klarheit im Inneren, Energie im Team und Orientierung nach außen.
                        Teams, die Freude und Sinn in der Arbeit erleben, sind leistungsfähiger, innovativer und gesünder. 
                        <br/>
                        <br/>
                        In unseren Workshops zeigen wir, wie Arbeitsglück Motivation, Leistung und Zusammenarbeit stärkt 
                        - wissenschaftlich fundiert, praxisnah und so gestaltet, dass Führungskräfte und Teams
                        sofort ins Handeln kommen.
                    </p>
                    <img id="bubble_academy_1" src="@/assets/bubble_red_1.png" alt="bubble">  
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- wave bottom -->
      <div class="c-wave c-wave-bottom"/>
    </div>

    <!-- course overview -->
    <div class="container-xl">
      <div class="row justify-content-center">
        <div class="col-11 col-md-10"> 
          <!-- happiness & work --> 
          <div class="row align-items-center pb-5">
            <div class="col-12 col-md-12 text-md-left">
              <h2 class="c-h2 c-txt-yellow" style="font-weight: bold;">Happiness & Work</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-5 order-md-2">
              <img src="@/assets/academy_haw-sm.png" alt="Academy_happiness_and_work" style="width: 310px;">
            </div>
            <div class="col-12 col-md-6 col-lg-7 order-md-1 py-md-2 text-left">
              <p>
                Viele Menschen haben noch nie bewusst darüber nachgedacht, was Glück im Arbeitskontext eigentlich bedeutet. 
                In diesem Workshop öffnen wir den Blick: Welche Rolle spielen Glück und positive Emotionen bei der Arbeit? 
                Was trägt jede:r selbst dazu bei - schon ab morgen? 
                Und wie kann das Team insgesamt leichter, produktiver und motivierter arbeiten?
              </p>
              <div class="d-flex justify-content-center justify-content-md-start">  
                <!-- button -->
                <router-link to="/academy/happiness_and_work" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Resillience --> 
          <div class="row align-items-center pb-5">
            <div class="col-12 col-md-12 text-md-right">
              <h2 class="c-h2 c-txt-blue" style="font-weight: bold;">Resilienz im Arbeitsalltag</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-5 order-md-1">
              <img src="@/assets/academy_resillience-sm.png" alt="Academy_Resillence" style="width: 310px;">
            </div>
            <div class="col-12 col-md-6 col-lg-7  order-md-2 py-md-2 text-right">
              <p>
                Warum gehen manche Menschen souverän mit Rückschlägen um, während andere lange hadern? 
                Resilienz ist keine feste Eigenschaft - sie ist trainierbar. 
                In diesem Workshop lernen die Teilnehmenden die sieben Schlüssel der Resilienz kennen und erarbeiten persönliche Strategien, 
                um im Arbeitsalltag gelassener und widerstandsfähiger zu agieren.
              </p>
              <div class="d-flex justify-content-center justify-content-md-start">  
                <!-- button -->
                <router-link to="/academy/resilience" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Positive Leadership --> 
          <div class="row align-items-center pb-5">
            <div class="col-12 col-md-12 text-md-left">
              <h2 class="c-h2 c-txt-orange" style="font-weight: bold;">Positive Leadership</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-5  order-md-2">
              <img src="@/assets/academy_pos_leadership-sm.png" alt="HappinessAndWork_Positive_Leadership" style="width: 310px;">
            </div>
            <div class="col-12 col-md-6 col-lg-7 order-md-1 py-md-2 text-left">
              <p>
                Positive Leadership ist einer der bestuntersuchten Führungsansätze unserer Zeit. Studien zeigen: 
                Positiv geführte Teams sind motivierter, gesünder und innovativer. 
                In diesem Workshop lernen Führungskräfte die Prinzipien kennen - und wie sie diese direkt im Alltag umsetzen können. 
                Jede:r Teilnehmende erhält außerdem ein individuelles PERMA-Lead-Profil.
              </p>
              <div class="d-flex justify-content-center justify-content-md-start">  
                <!-- button -->
                <router-link to="/academy/positive_leadership" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Strength --> 
          <div class="row align-items-center pb-5">
            <div class="col-12 col-md-12 text-md-right">
              <h2 class="c-h2 c-txt-yellow" style="font-weight: bold;">Stärken & Teamrollen</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-5  order-md-1">
              <img src="@/assets/academy_strengths-sm.png" alt="Academy_Strengths_and_Team_Roles" style="width: 310px;">
            </div>
            <div class="col-12 col-md-6 col-lg-7 order-md-2 py-md-2 text-right">
              <p>
                Stärkenorientierung bringt Leichtigkeit und Freude in die Arbeit - und macht Teams erfolgreicher. 
                In diesem Workshop entdecken Teilnehmende ihre individuellen Stärken und Rollen im Team. Wir analysieren, 
                warum manche Teams hochproduktiv sind, während andere auf der Stelle treten, 
                und zeigen, wie Konflikte als Chance genutzt werden können.
              </p>
              <div class="d-flex justify-content-center justify-content-md-start">  
                <!-- button -->
                <router-link to="/academy/strengths" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Effective communication --> 
          <div class="row align-items-center pb-5">
            <div class="col-12 col-md-12 text-md-left">
              <h2 class="c-h2 c-txt-blue" style="font-weight: bold;">Wirksam kommunizieren</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-5 order-md-2">
              <img src="@/assets/academy_effect_com-sm.png" alt="HappinessAndWork_Effective_communication" style="width: 310px;">
            </div>
            <div class="col-12 col-md-6 col-lg-7 order-md-1 py-md-2 text-left">
              <p>
                Sprache prägt Zusammenarbeit. In diesem Workshop beschäftigen wir uns mit den Mechanismen von Kommunikation: 
                Warum kommt meine Botschaft manchmal nicht an? Wie lassen sich Missverständnisse vermeiden? 
                Wir arbeiten mit Erkenntnissen der Lernpsychologie, 
                der Werbepsychologie und Elementen der gewaltfreien Kommunikation (Marshall Rosenberg).
              </p>
              <div class="d-flex justify-content-center justify-content-md-start">  
                <!-- button -->
                <router-link to="/academy/effective_communication" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <!-- Team Development --> 
          <div class="row align-items-center pb-5">
            <div class="col-12 col-md-12 text-md-right">
              <h2 class="c-h2 c-txt-orange" style="font-weight: bold;">Team- & Organisationsentwicklung</h2>
            </div>
            <div class="col-12 col-md-6 col-lg-5 order-md-1">
              <img src="@/assets/academy_team_dev-sm.png" alt="Academy_Team_Development" style="width: 310px;">
            </div>
            <div class="col-12 col-md-6 col-lg-7 order-md-2 py-md-2 text-right">
              <p>
                Nicht jedes Anliegen passt in ein Standard-Format. Ob Veränderungsbegleitung, 
                Prozessoptimierung oder komplexe Organisationsentwicklung 
                - wir entwickeln gemeinsam mit Ihnen ein Konzept, das zu Ihrem Team und Ihren Zielen passt.
              </p>
              <div class="d-flex justify-content-center justify-content-md-start">  
                <!-- button -->
                <router-link to="/academy/team_development" style="text-decoration: none">
                  <div class="c-btn c-btn-orange" >
                    <span style="padding: 5px">Mehr Infos</span>
                    <div class="c-btn-img c-btn-img-right-white"/>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="c-orange-bg">   
      <!-- wave top -->
      <div class="c-wave c-wave-top" style="position: relative; top:-2px;"/>
      <!-- footer content -->
      <div class="container-xl">
        <div class="row c-txt-white c-footer">
          <div class="col-12">
            <Footer></Footer>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Navi from '@/components/Navi.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Academy_SAT',
  components: {
    Navi,
    Footer
  },
  metaInfo() {
    // patch meta data on current page
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: `${this.metaTitle}`,
      meta: [
        { vmid: "keywords",  name: 'keywords', content: `${this.metaKeywords}` },
        { vmid: "description", name: 'description', content: `${this.metaDescription}`},
        // social tagging
        { vmid: "og:title", property: "og:title", content: `${this.metaTitle}` },
        { vmid: "og:url", property: "og:url", content: `${this.metaUrl}` },
        { vmid: "og:description", property: "og:description", content: `${this.metaDescription}` },
        { vmid: "og:image", name: 'og:image', content: `${this.metaImage}` }
      ]
    }
  },
  data() {
    return {
      // metaData
      metaTitle: "- Academy - Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind?",
      metaDescription: "Wie schafft es eine Organisation, dass ihre Mitarbeiter glücklich sind? Die Felicicon GmbH hat Weiterbildungsangebote für Mitarbeiter und Führungskräfte und führen in Mitarbeiter Events in das Thema ein.",
      metaUrl: "/academy",
      metaKeywords: "Seminar Beratung Coaching Teamentwicklung Keynotes 'Happinessandwork Academy'",
      metaImage: "https://www.happinessandwork.de/share/academy.png"
    }
  },
  // called when component is mounted to the dom
  mounted: function () {
    // Create render evnt puppeteer is waiting for when prerender pager (see param: renderAfterDocumentEvent)
    document.dispatchEvent(new Event('render-event'))
  },
  methods: {
  }
}

</script>

<style>
</style>
